import { css } from '@emotion/core';
import { tokens, globalTokens } from '@domain-group/fe-brary';
import { truncateLines, designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
var _ref = {
  name: "pzhbbb",
  styles: "min-width:122px;max-width:122px;"
};
export var agencyDetails = isVerticalCard => /*#__PURE__*/css("position:relative;color:", colors.neutral.heavy.default, ";min-width:170px;max-width:170px;border-left:1px solid ", globalTokens.colors.neutralGrey200, ";", isVerticalCard && _ref);
export var inner = isVerticalCard => /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:flex-start;gap:8px;padding:0 0 0 16px;min-height:", isVerticalCard ? '118px' : '136px', ";");
export var name = isVerticalCard => /*#__PURE__*/css(isVerticalCard ? /*#__PURE__*/css(designTokenFonts.body, " line-height:20px;") : /*#__PURE__*/css(designTokenFonts.mini), " ", truncateLines(isVerticalCard ? 3 : 2), " width:100%;overflow:hidden;overflow-wrap:break-word;height:", isVerticalCard ? 'auto' : '40px', ";");
export var agencyLink = {
  name: "1que1r7",
  styles: "text-decoration:none;color:inherit;&::before{position:absolute;top:0;right:0;left:0;bottom:0;content:'';}"
};
export var agencyName = {
  name: "dxjffr",
  styles: "text-decoration:none;line-height:normal;"
};
export var agencyLogo = {
  name: "1odjf1w",
  styles: "width:90px;height:40px;margin-top:8px;max-width:120px;object-fit:contain;object-position:left;"
};
export var agencyLogoName = isVerticalCard => /*#__PURE__*/css(designTokenFonts.mini, " display:block;text-decoration:none;margin-bottom:7px;width:", isVerticalCard ? '100%' : '138px', ";", truncateLines(2), " color:", colors.neutral.medium.default, ";");
var _ref2 = {
  name: "gx0lhm",
  styles: "margin-bottom:0;"
};
export var type = isVerticalCard => /*#__PURE__*/css(agencyName, " ", isVerticalCard && _ref2);